<template>
	<div class="events-footer">
		<div class="events-container flex justify-between items-center h-full">
			<div>© Pixellot. {{ $tc('footer.rights') }}</div>
			<div>
				<a href="/my-pixellot/privacy-policy/" target="_blank">{{ $tc('footer.privacyPolicy') }}</a>
				<a href="/my-pixellot/terms-use/" target="_blank" class="pl-10 pr-10">{{ $tc('footer.terms') }}</a>
				<a href="/my-pixellot/accessibility/" target="_blank">{{ $tc('footer.accessibility') }}</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'EventsFooter'
}
</script>

<style lang="scss">
  .events-footer {
    z-index: 10;
    position: relative;
    background-color: rgba(33, 33, 33, 0.9);
    /*padding: 16px 0 14px;*/
    height: $headerHeight;
    font-size: 12px;
    color: #b7b7b7;

    a {
      color: #a4a4a4;
      transition: 0.3s color;
      &:hover {
        color: $white;
      }
    }

    @include respond-below(tablet) {
      flex-direction: column;
      justify-content: space-around;
    }
  }
</style>
